import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {CountryKeys} from 'shared/lib'
import {Gender, ChildrenCount, MaritalStatus, Education, InterestCategory} from 'shared/types'

export type UserType = {
  id: string
  name: string
  gender: Gender
  education: Education
  avatarUrl: string | null
  videoAvatarUrl: string | null
  bannerUrl: string | null
  age: number
  city: string | null
  country: CountryKeys | null
  dateBirth: string
  maritalStatus: MaritalStatus
  childrenCount: ChildrenCount
  occupation: string | null
  about: string | null
  isOnline: boolean
  isPopular: boolean
  isBlocked: boolean
  isConfirmed: boolean
  interests: InterestCategory[]
}

const initialState: UserType = {
  about: '',
  age: 0,
  avatarUrl: '',
  bannerUrl: '',
  childrenCount: 0,
  city: '',
  country: null,
  dateBirth: '',
  gender: Gender.FEMALE,
  id: '',
  isOnline: false,
  maritalStatus: MaritalStatus.NOT_MARRIED,
  education: Education.NOT_SPECIFIED,
  name: '',
  occupation: '',
  videoAvatarUrl: '',
  isPopular: false,
  isBlocked: false,
  isConfirmed: false,
  interests: [],
}

export const profileModel = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, {payload}: PayloadAction<UserType | null>) => {
      if (payload == null) return {...state, isBlocked: true}
      return {...state, ...payload}
    },
    clearProfile: () => initialState
  }
})

export const {setProfile, clearProfile} = profileModel.actions

export const useProfile = () => useSelector((state: RootState) => state.profile)
